// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
export const CostumerConsultantFragmentDoc = gql`
    fragment costumerConsultant on Consultant {
  id
  avatarImage {
    __typename
    url
  }
  firstName
  user {
    id
    email
  }
}
    `;